import numeral from "numeral";

class Utils {
  static commafy(num) {
    return numeral(num).format("0,0.00");
  }
}

export default Utils;
